/* ============
 * Package Unit Type Transformer
 * ============
 *
 * The transformer for the packageUnitTypes.
 */

import Transformer from './transformer';

export default class UnitTypeTransformer extends Transformer {

  static fetch(unitType) {
    return {
      id: unitType.id,
      name: unitType.name,
    };
  }

  static send(unitType) {
    return {
      id: unitType.id,
      name: unitType.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/unitType.js